import React from 'react';
import { useTranslation } from 'react-i18next';
import { tv } from '@/utils/tv';
import { Size } from '@/types/components';

const spinner = tv({
  base: 'inline-block animate-spin rounded-full border-current border-t-transparent',
  variants: {
    size: {
      [Size.Small]: 'size-4 border-[1.5px]',
      [Size.Medium]: 'size-6 border-2',
      [Size.Large]: 'size-8 border-[2.5px]',
    },
  },
});

interface Props {
  size?: Size;
}

export const Spinner: React.FC<Props> = ({ size = Size.Medium }) => {
  const { t } = useTranslation();

  return (
    <span
      role="status"
      aria-label={t('global.loading')}
      className={spinner({ size })}
    />
  );
};
